module.exports = __webpack_public_path__ + "img/star-half.270008d.png";